<template>
  <div
    class="avatar-name"
  >
    <span>{{ getGroupName() }}</span>
  </div>
</template>

<script>
export default {
  name: 'AvatarName',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    getGroupName() {
      if (!this.name) {
        return '';
      }

      const nameDivided = this.name.split(' ');

      if (nameDivided.length > 1) {
        const [name, lastName] = nameDivided;

        const firstNameCapitalLetter = name[1];
        const lastNameCapitalLetter = lastName[0];

        return `${firstNameCapitalLetter.toUpperCase()}${lastNameCapitalLetter.toUpperCase()}`;
      }

      const getFirstLetter = nameDivided[0].slice(1, 2).toUpperCase();

      return getFirstLetter;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-name {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--ds-spacing-stack-md);
  height: var(--ds-spacing-stack-md);
  border-radius: 50%;
  overflow: hidden;
  font-weight: 600;
  color: var(--ds-color-white-text);
  background-color: var(--ds-color-interactive);
}
</style>
